import { MarketBlogsPage } from '../../../components/market/MarketBlogsPage'
import { getMarketBlogProps } from '../../../lib/market-pages'
import copy from '../../../data/markets/my/blogs'

// Guide listing for this country - see components/market/MarketBlogsPage.
export const getStaticProps = () => getMarketBlogProps('my')

export default function Page(props) {
    return <MarketBlogsPage {...props} copy={copy} />
}
